










































import { Vue, Component, Watch } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Schedule, DateSchedule } from '@/types/schedule'
import { DateString } from '@/types/utils'
import { Filter } from '@/store/schedule/types'
import ScheduleList from '@/components/schedules/ScheduleList.vue'
import Calendar from '@/components/schedules/Calendar.vue'
import CallBtn from '@/components/schedules/CallBtn.vue'
import PatientSearchField from '@/components/schedules/PatientSearchField.vue'
import dayjs from 'dayjs'

@Component({
  components: {
    ScheduleList,
    Calendar,
    PatientSearchField,
    CallBtn
  }
})
export default class Schedules extends Vue {
  readonly DATE_FORMAT = 'YYYY-MM-DD'
  readonly today = dayjs().format(this.DATE_FORMAT) as DateString
  $store!: ExStore
  schedules: DateSchedule[] = []

  @Watch('patient')
  onChangePatient() {
    this.getSchedules()
  }

  get dateForCalendar() {
    if (!this.calendarSetting.dateForCalendar) return this.today
    return this.calendarSetting.dateForCalendar
  }

  set dateForCalendar(dateForCalendar: DateString) {
    this.$store.dispatch('schedule/updateCalendar', { dateForCalendar })
  }

  get targetDate() {
    if (!this.calendarSetting.targetDate) return this.today
    return this.calendarSetting.targetDate
  }

  set targetDate(targetDate: DateString) {
    this.$store.dispatch('schedule/updateCalendar', { targetDate })
  }

  get filter() {
    return this.calendarSetting.filter
  }

  set filter(filter: Filter) {
    this.$store.dispatch('schedule/updateCalendar', { filter })
  }

  get calendarSetting() {
    return this.$store.getters['schedule/calendar']
  }

  get patientId() {
    return this.patient ? this.patient.id : undefined
  }

  get patient() {
    return this.$store.getters['patient/currentPatient']
  }

  get filteredSchedules() {
    const schedules = this.schedules
      .map(ds => {
        return {
          date: ds.date,
          schedules: ds.schedules.filter(s => {
            return this.filter === 'own' ? this.isOwnSchedule(s) : s
          })
        }
      })
      .sort((a, b) => {
        const aD = new Date(a.date)
        const bD = new Date(b.date)
        return aD.getTime() - bD.getTime()
      })
    return schedules.filter(ds => !!ds.schedules.length)
  }

  get yearForCalendar() {
    return dayjs(this.dateForCalendar).year()
  }
  get monthForCalendar() {
    return dayjs(this.dateForCalendar).month() + 1
  }

  async created() {
    const { filter, patientId, targetDate, searchWord } = this.$route.query
    if (filter) this.filter = filter as Filter
    if (patientId) {
      this.$store.dispatch('patient/updateCurrentPatient', {
        patientId: Number(patientId)
      })
    }
    if (searchWord)
      this.$store.dispatch('schedule/updateCalendar', {
        searchWord: String(searchWord)
      })
    if (targetDate) {
      this.targetDate = targetDate as DateString
      this.dateForCalendar = targetDate as DateString
    }
    await this.getSchedules()
  }

  async getSchedules() {
    try {
      const month = this.monthForCalendar
      const year = this.yearForCalendar
      const patientId = this.patientId
      const schedules = await this.$api.schedule.calendar({
        month,
        year,
        patientId
      })
      this.schedules = schedules.results
    } catch (e) {
      console.error(e)
    }
  }

  isOwnSchedule(schedule: Schedule) {
    const userInfo = this.$store.getters['user/userInfo']
    return schedule.worker.id === userInfo.id
  }

  addCalendarMonth(month: number) {
    const date = dayjs(this.dateForCalendar)
    this.dateForCalendar = date
      .add(month, 'month')
      .format(this.DATE_FORMAT) as DateString
  }

  setTargetDateFromCalendarMonth() {
    this.targetDate = dayjs(this.dateForCalendar).format(
      'YYYY-MM-01'
    ) as DateString
  }

  async onCallBtnClick() {
    const patient = this.$store.getters['patient/currentPatient']
    if (patient) this.$store.dispatch('call/addCallPartners', [patient])
    this.$store.dispatch('call/displayUserselectModal', true)
  }

  onFilterClick(filter: string) {
    this.filter = filter as Filter
  }

  onCalendarDayClick(date: string) {
    this.targetDate = dayjs(date).format(this.DATE_FORMAT) as DateString
  }

  onCalendarNextMonthClick() {
    this.addCalendarMonth(1)
    this.setTargetDateFromCalendarMonth()
    this.getSchedules()
  }

  onCalendarPrevMonthClick() {
    this.addCalendarMonth(-1)
    this.setTargetDateFromCalendarMonth()
    this.getSchedules()
  }

  onPatientSelect(id: number | null) {
    this.$store.dispatch('patient/updateCurrentPatient', { patientId: id })
  }
}
